import _extends from '@babel/runtime/helpers/extends';
import React__default, { memo, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { B as Button } from '../Button/Button-rs5QufkK.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { I as Icon } from '../Icon/Icon-CqA2URu0.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

const StyledArrowButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30061128__sc-1d1l5l5-0"
})(["background:none;border:none;cursor:pointer;width:", ";padding:0;display:flex;margin:0;justify-content:center;align-items:center;:hover{background:none;}@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}", " ", ""], ({
  theme
}) => theme.tree.arrowButtonWidth, ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ transform:rotate(-90deg);}"]), isMobile(css(["font-size:1.2em;width:", ";"], ({
  theme
}) => theme.tree.mobile.arrowButtonWidth)));
const hasSiblingWithArrowButtonMixin = /*#__PURE__*/css(["width:", ";", ""], ({
  theme
}) => theme.tree.arrowButtonWidth, isMobile(css(["width:", ";"], ({
  theme
}) => theme.tree.mobile.arrowButtonWidth)));
const ArrowButtonSpacer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30061128__sc-1d1l5l5-1"
})(["flex:0 0 auto;width:", ";", " ", ""], ({
  theme
}) => theme.tree.arrowButtonSpacerWidth, isMobile(css(["width:", ";"], ({
  theme
}) => theme.tree.mobile.arrowButtonSpacerWidth)), ({
  hasSiblingWithArrowButton
}) => hasSiblingWithArrowButton && hasSiblingWithArrowButtonMixin);
const isTreeRoleMixin = /*#__PURE__*/css(["width:", ";", ""], ({
  theme
}) => theme.tree.arrowButtonDisplayAllTreeNodeSpacerWidth, isMobile(css(["width:", ";"], ({
  theme
}) => theme.tree.mobile.arrowButtonDisplayAllTreeNodeSpacerWidth)));
const DisplayAllSpacer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30061128__sc-1d1l5l5-2"
})(["flex:0 0 auto;width:", ";", " ", ""], ({
  theme
}) => theme.tree.arrowButtonDisplayAllSpacerWidth, isMobile(css(["width:", ";"], ({
  theme
}) => theme.tree.mobile.arrowButtonDisplayAllSpacerWidth)), ({
  isTreeRole
}) => isTreeRole && isTreeRoleMixin);
const NoArrowSpacer = ({
  displayAll,
  hasSiblingWithArrowButton,
  isTreeRole
}) => {
  if (displayAll) {
    return /*#__PURE__*/React__default.createElement(DisplayAllSpacer, {
      isTreeRole: isTreeRole
    });
  }
  return /*#__PURE__*/React__default.createElement(ArrowButtonSpacer, {
    hasSiblingWithArrowButton: hasSiblingWithArrowButton
  });
};
function ArrowButton({
  item,
  onArrowClick,
  opened,
  ariaLabel,
  taktId,
  taktValue
}) {
  const handleArrowClick = useCallback(() => onArrowClick(item), [item, onArrowClick]);
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('tree')
  });
  const {
    children,
    renderLabel,
    ...rest
  } = item;
  return /*#__PURE__*/React__default.createElement(StyledArrowButton, _extends({
    "data-test-id": `option-expander-${item.label}`,
    transparent: true,
    type: "button",
    onClick: handleArrowClick,
    $opened: opened,
    "aria-expanded": opened,
    "aria-label": ariaLabel
  }, getDataTaktAttributes({
    taktIdSuffix: `${item.id.toString()}-arrow`,
    taktValue,
    contextOnlyTaktValues: {
      item: rest
    }
  })), /*#__PURE__*/React__default.createElement(Icon, {
    type: angleInlineEnd
  }));
}
var ArrowButton$1 = /*#__PURE__*/memo(ArrowButton);

export { ArrowButton$1 as A, NoArrowSpacer as N };
//# sourceMappingURL=ArrowButton-DoaDYmGa.js.map
